import { render, staticRenderFns } from "./RatesMultiPoint.vue?vue&type=template&id=1518ee2a&scoped=true&"
import script from "./RatesMultiPoint.vue?vue&type=script&lang=js&"
export * from "./RatesMultiPoint.vue?vue&type=script&lang=js&"
import style0 from "./RatesMultiPoint.vue?vue&type=style&index=0&id=1518ee2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1518ee2a",
  null
  
)

export default component.exports